import type { SystemOptionType } from 'data/types';

export const SYSTEM_COLUMN_COUNT = 3;

export type PendingColumnSelection = {
  slotIndex: number;
  uniqueId: string;
};

export type ColumnTarget =
  | { kind: 'swap'; replaceSystemId: string }
  | { kind: 'add' };

export type ColumnReconciliation = {
  idsToRemove: string[];
  systemsToAdd: SystemOptionType[];
};

export type ColumnPlacement = {
  columns: string[];
  placed: boolean;
};

export function swapColumnSlot(
  current: ReadonlyArray<string>,
  slotIndex: number,
  systemId: string
): string[] {
  return current.map((id, index) => (index === slotIndex ? systemId : id));
}

export function placeColumnSystem(
  current: ReadonlyArray<string>,
  target: ColumnTarget,
  systemId: string
): ColumnPlacement {
  const swapIndex =
    target.kind === 'swap' ? current.indexOf(target.replaceSystemId) : -1;
  if (swapIndex !== -1) {
    return {
      columns: swapColumnSlot(current, swapIndex, systemId),
      placed: true
    };
  }
  if (current.length < SYSTEM_COLUMN_COUNT) {
    return { columns: [...current, systemId], placed: true };
  }
  return { columns: [...current], placed: false };
}

export function reconcileComparisonColumns(
  columnIds: ReadonlyArray<string>,
  columnSystems: ReadonlyArray<SystemOptionType>,
  comparedSystems: ReadonlyArray<SystemOptionType>,
  pendingPlacementIds: ReadonlySet<string>
): ColumnReconciliation {
  const keptIds = new Set(columnIds);
  const comparedIds = new Set(comparedSystems.map((system) => system.id));
  return {
    idsToRemove: comparedSystems
      .filter(
        (system) =>
          !keptIds.has(system.id) && !pendingPlacementIds.has(system.id)
      )
      .map((system) => system.id),
    systemsToAdd: columnSystems.filter((system) => !comparedIds.has(system.id))
  };
}
